const number = (reverse = false) => (a, b) => (
  reverse ?
    parseInt(a, 10) - parseInt(b, 10) :
    parseInt(b, 10) - parseInt(a, 10)
);

const string = (reverse = false) => (a, b) => (
  reverse ? b.localeCompare(a) : a.localeCompare(b)
);

export default {
  number,
  string,
};



// WEBPACK FOOTER //
// ./app/utils/sort/index.js